import Axios from "axios";
import { ApiResultModel } from "../models/common.model";
import {
  AddPermissionGroupRequest,
  AddPermissionRequest,
  AddPermissionResponse,
  EditPermissionGroupRequest,
  EditPermissionRequest,
  GetPermissionGroupsResponse,
  GetPermissionGroupsWithSubPermissionsResponse,
  GetPermissionsSearchRequest,
  GetPermissionsSearchResponse,
} from "../models/permission.model";
import { ApiBaseUrl, PermissionUrl } from "../config/config";

export const GetPermissionsSearch = async (
  data: GetPermissionsSearchRequest
): Promise<GetPermissionsSearchResponse[]> => {
  return await Axios.post<ApiResultModel<GetPermissionsSearchResponse[]>>(
    ApiBaseUrl + PermissionUrl + "/GetPermissionsSearch",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const AddPermission = async (
  data: AddPermissionRequest
): Promise<AddPermissionResponse> => {
  return await Axios.post<ApiResultModel<AddPermissionResponse>>(
    ApiBaseUrl + PermissionUrl + "/AddPermission",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const EditPermission = async (
  data: EditPermissionRequest
): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + PermissionUrl + "/EditPermission",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const DeletePermission = async (data: {
  permissionId: number;
}): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + PermissionUrl + "/DeletePermission",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const GetPermissionGroupsWithSubPermissions = async (data: {
  permissionGroupId?: number;
}): Promise<GetPermissionGroupsWithSubPermissionsResponse[]> => {
  return await Axios.post<
    ApiResultModel<GetPermissionGroupsWithSubPermissionsResponse[]>
  >(
    ApiBaseUrl + PermissionUrl + "/GetPermissionGroupsWithSubPermissions",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const AddPermissionGroup = async (
  data: AddPermissionGroupRequest
): Promise<AddPermissionResponse> => {
  return await Axios.post<ApiResultModel<AddPermissionResponse>>(
    ApiBaseUrl + PermissionUrl + "/AddPermissionGroup",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const EditPermissionGroup = async (
  data: EditPermissionGroupRequest
): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + PermissionUrl + "/EditPermissionGroup",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const DeletePermissionGroup = async (data: {
  permissionGroupId: number;
}): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + PermissionUrl + "/DeletePermissionGroup",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const GetPermissionGroups = async (data: {
  permissionGroupId?: number;
}): Promise<GetPermissionGroupsResponse[]> => {
  return await Axios.post<ApiResultModel<GetPermissionGroupsResponse[]>>(
    ApiBaseUrl + PermissionUrl + "/GetPermissionGroups",
    data
  ).then((result) => {
    return result.data.data;
  });
};
